module.exports = __webpack_public_path__ + "img/1-4.4ea05aa3.jpg";